import { render } from "./Last10DaysLeads.vue?vue&type=template&id=17a2e2cb"
import script from "./Last10DaysLeads.vue?vue&type=script&lang=js"
export * from "./Last10DaysLeads.vue?vue&type=script&lang=js"
script.render = render

export default script